import api from './interceptor';

const BASE_URL_V2 = 'api/v2/rpm';

export default {
  // API Version 2
  getRpmApis: () => api.get(`${BASE_URL_V2}/apis`),
};
